import {NextPageContextEnhanced} from "../../types/page";
import { ICityAsset } from "models/Assets/ICityAsset";
import {IOptionWithCounts} from "models/base/Generics";
import { INeighborhoodLiteAsset } from "models/Assets/INeighborhoodAsset";
import {
  filterCityByUrlName,
  filterNeighborhoodByNeighborhoodUrlName,
} from "dataLayer/filters/citiesAndHoods";

export const AUTO_SERVICES_BASE_PREFIX_AR = "مراكز-خدمات-السيارات";
export const AUTO_SERVICES_BASE_PREFIX_EN = "autos-service-center";

export const AUTO_SERVICES_BRANDS_PREFIX_AR = "انواع-السيارات";
export const AUTO_SERVICES_BRANDS_PREFIX_EN = "cars-brands";

export const AUTO_SERVICES_SERVICES_PREFIX_AR = "الخدمات";
export const AUTO_SERVICES_SERVICES_PREFIX_EN = "services";

export const AUTO_SERVICES_DETAILS_PREFIX_AR = "مراكز";
export const AUTO_SERVICES_DETAILS_PREFIX_EN = "centers";

export type AutoServiceCenterPageType =
  | "main"
  | "details"
  | "services"
  | "carMakes";

export interface ISelectedAutoServiceCenterObjects {
  carMake?: IOptionWithCounts;
  service?: IOptionWithCounts;
  city?: ICityAsset;
  neighborhood?: INeighborhoodLiteAsset;
  pageType?: AutoServiceCenterPageType;
  autoServiceCenterId?: number;
}

export interface IAutoServiceCenterOptionsCollection {
  carMakes: IOptionWithCounts[];
  services: IOptionWithCounts[];
  cities: ICityAsset[];
}

const filterSelectedObject = (items: IOptionWithCounts[], url_name: string) => {
  return items
    .filter((c) => c.url_name_ar && c.url_name_en)
    .filter(
      (b) => b.url_name_ar === url_name || b.url_name_en === url_name
    )?.[0] || null;
};

export const parseAutoServiceCenterUrlData = (
  context: NextPageContextEnhanced,
  options: IAutoServiceCenterOptionsCollection
): ISelectedAutoServiceCenterObjects => {
  let url = context.requestUri;
  const lang = context.lang;
  url =url.split(`/${lang}`)[1].split("?")[0];


  // -- ALGO --------------------

  const matchedObjects: ISelectedAutoServiceCenterObjects = {
    pageType:
      (url.includes(AUTO_SERVICES_DETAILS_PREFIX_EN + "/") ||
      url.includes(AUTO_SERVICES_DETAILS_PREFIX_AR + "/"))
        ? "details"
        : (url.includes(AUTO_SERVICES_BRANDS_PREFIX_EN + "/") ||
          url.includes(AUTO_SERVICES_BRANDS_PREFIX_AR + "/"))
        ? "carMakes"
        : (url.includes(AUTO_SERVICES_SERVICES_PREFIX_EN + "/") ||
          url.includes(AUTO_SERVICES_SERVICES_PREFIX_AR + "/"))
        ? "services"
        : "main",
  };


  const pageTypesSegments = [
    AUTO_SERVICES_BASE_PREFIX_AR,
    AUTO_SERVICES_BASE_PREFIX_EN,
    AUTO_SERVICES_SERVICES_PREFIX_EN,
    AUTO_SERVICES_SERVICES_PREFIX_AR,
    AUTO_SERVICES_BRANDS_PREFIX_AR,
    AUTO_SERVICES_BRANDS_PREFIX_EN,
    AUTO_SERVICES_DETAILS_PREFIX_AR,
    AUTO_SERVICES_DETAILS_PREFIX_EN,
  ];

  const [cityUrlName, hoodUrlName] = url.split("/").filter(Boolean).filter((segment)=>!pageTypesSegments.includes(segment));

  matchedObjects.city = filterCityByUrlName(options.cities, cityUrlName);
  matchedObjects.neighborhood = filterNeighborhoodByNeighborhoodUrlName(
    matchedObjects.city?.pwaNeighborhoods,
    hoodUrlName
  );

  if (matchedObjects.pageType === "carMakes") {
    const [_, carMakeUrlName] = url.split(
      lang === "ar"
        ? AUTO_SERVICES_BRANDS_PREFIX_AR + "/"
        : AUTO_SERVICES_BRANDS_PREFIX_EN + "/"
    );

    matchedObjects.carMake = filterSelectedObject(
      options.carMakes,
      carMakeUrlName
    );
  }

  if (matchedObjects.pageType === "services") {
    const [_, service_brand] = url.split(
      lang === "ar"
        ? AUTO_SERVICES_SERVICES_PREFIX_AR + "/"
        : AUTO_SERVICES_SERVICES_PREFIX_EN + "/"
    );

    const [serviceUrlName, carMakeUrlName] = service_brand
      .split("/")
      .filter(Boolean);
    matchedObjects.carMake = filterSelectedObject(
      options.carMakes,
      carMakeUrlName
    );
    matchedObjects.service = filterSelectedObject(
      options.services,
      serviceUrlName
    );
  }
  if (matchedObjects.pageType === "details") {
    const [_, slug] = url.split(
        lang === "ar"
            ? AUTO_SERVICES_DETAILS_PREFIX_AR + "/"
            : AUTO_SERVICES_DETAILS_PREFIX_EN + "/"
    );


    matchedObjects.autoServiceCenterId = parseInt(slug);
  }

  return matchedObjects;
};
